import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
// import { getCurrencyConfig } from "./auth";

dayjs.extend(duration);

type Currency = {
    code: string;
    rateToUSD: number;
    symbol: string
};

function formatPrice(num: string | number) {
    const price = Number(num);
    return isNaN(price) ? "$ 0.00" : `$ ${price.toFixed(2)}`;
}

const formatKHR = (amount: number) => {
    return `៛ ${new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 0,
    }).format(amount)}`;
};

function getToken() {
    return localStorage.getItem("token");
}

const round = (value: number, decimals = 2) =>
    Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

const convertToBusinessCurrency = (
    amount: number,
    amountCurrency: string,
    businessCurrency: string,
    currencies: Currency[]
) => {
    if (amountCurrency === businessCurrency) return amount;

    const from = currencies.find(c => c.code === amountCurrency);
    const to = currencies.find(c => c.code === businessCurrency);

    if (!from || !to) return amount;

    const amountInUSD =
        amountCurrency === "USD"
            ? amount
            : amount / from.rateToUSD;

    const result =
        businessCurrency === "USD"
            ? amountInUSD
            : amountInUSD * to.rateToUSD;

    return round(result, businessCurrency === "USD" ? 2 : 0);
};


export const convertAndFormatCurrency = (
    amount: number,
    amountCurrency: string,
    businessCurrency: string,
    currencies: Currency[]
) => {
    const converted = convertToBusinessCurrency(
        amount,
        amountCurrency,
        businessCurrency,
        currencies
    );

    const currency = currencies.find(c => c.code === businessCurrency);

    const symbol = currency?.symbol || businessCurrency;

    const formatted = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: businessCurrency === "USD" ? 2 : 0,
        maximumFractionDigits: businessCurrency === "USD" ? 2 : 0,
    }).format(converted);

    return `${symbol} ${formatted}`;
};

// export function formatPriceNew(num: string | number, currency?: string) {
//     const price = Number(num);
//     const code = getCurrencyConfig()?.code || "USD";
//     const symbol = getCurrencySymbol();

//     if (isNaN(price)) {
//         if (code.toUpperCase() === "USD") {
//             return `${symbol} 0.00`;
//         }
//         return `${symbol} 0`;
//     }

//     if (code.toUpperCase() === "USD") {
//         return `${symbol} ${price.toFixed(2)}`;
//     }

//     return `${symbol} ${price.toLocaleString(undefined, {
//         minimumFractionDigits: 0,
//         maximumFractionDigits: 2
//     })}`;
// }


export function fromCurrency(
    price: number,
    rateToUSD?: number,
    currencyCode?: string,
): number {
    const rate = rateToUSD;
    const basePrice = price;
    if (!basePrice) return 0;
    if (currencyCode === "USD" || !rate) {
        return Math.floor(Number(basePrice) * 100) / 100;
    }

    return Math.floor(Number(basePrice) * rate * 100) / 100;
}

function convertToBaseAmount(
    amountInUSD: number,
    baseCurrencyCode: string,
    baseRateToUSD?: number | null,
): number {
    return fromCurrency(
        amountInUSD,
        baseRateToUSD == null ? undefined : baseRateToUSD,
        baseCurrencyCode,
    );
}

function formatPriceByCurrency(num: string | number, currency?: string) {
    const price = Number(num);
    if (isNaN(price)) return `${currency ?? "$"} 0.00`;

    if (currency === "$") {
        return `${currency ?? "$"} ${price.toFixed(2)}`;
    }

    return `${currency ?? ""} ${price.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    })}`;
}

export {
    formatPrice,
    getToken,
    convertToBusinessCurrency,
    formatKHR,
    convertToBaseAmount,
    formatPriceByCurrency
};
